import { call, put, takeLatest } from "redux-saga/effects";
import { push } from "react-router-redux";
import swal from "sweetalert";
import api from "services/api";

import {
  Creators as UsersActions,
  Types as UsersTypes,
} from "store/ducks/users";

function* getUserRequest(action) {
  try {
    const { id } = action.payload;
    const url = `user/v2/inhabitants/${id}`;
    const response = yield call(api.get, url);

    yield put(UsersActions.getUserSuccess(response.data));
  } catch (error) {
    yield put(UsersActions.getUserFailure());
  }
}

function filterUsers(filters) {
  if (filters !== null) {
    const name = filters.name !== "" ? `&name=${filters.name}` : "";
    const ldap = filters.ldap !== "" ? `&ldap=${filters.ldap}` : "";
    const group =
      filters.group !== null && filters.group.value !== null
        ? `&access_group_id=${filters.group.value}`
        : "";

    return `${name}${ldap}${group}`;
  }

  return "";
}

function* getUsersRequest(action) {
  try {
    const { page, filters } = action.payload;
    const filter = yield call(filterUsers, filters);
    const url = `user/v2/inhabitants?page=${page}&per=25&coworker=1${filter}`;
    const response = yield call(api.get, url);

    yield put(UsersActions.getUsersSuccess(response.data, page));
  } catch (error) {
    yield put(UsersActions.getUsersFailure());
  }
}

function* updateUserRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `auth/v2/users/${id}`;
    yield call(api.put, url, data);

    yield put(push("/configs/users"));
    yield call(swal, "Atualizado", "Usuário atualizado", "success");
    yield put(UsersActions.updateUserSuccess());
  } catch (error) {
    yield call(
      swal,
      "Falha ao atualizar",
      "Não foi possível atualizar o usuário.",
      "error",
    );
    yield put(UsersActions.updateUserFailure());
  }
}

function* getUsersGroupsRequest(action) {
  try {
    const { query } = action.payload;
    const url = `auth/v2/groups?search=${query}&per=20`;
    const response = yield call(api.get, url);

    yield put(UsersActions.getUsersGroupsSuccess(response.data));
  } catch (error) {
    yield put(UsersActions.getUsersGroupsFailure());
  }
}

export default function* sagaUsers() {
  yield takeLatest(UsersTypes.GET_REQUEST, getUserRequest);
  yield takeLatest(UsersTypes.GET_LIST_REQUEST, getUsersRequest);
  yield takeLatest(UsersTypes.UPDATE_REQUEST, updateUserRequest);
  yield takeLatest(UsersTypes.GET_GROUPS_REQUEST, getUsersGroupsRequest);
}
